export default __webpack_public_path__ + "static/media/start-k-8-thumb.92d04bda.jpg";